import styled, { css, keyframes } from 'styled-components';
import colors from 'styles/colors';

// Visual fiel ao protótipo do Figma "Dr. Licita 3.0" (página Inicial e
// fluxo de conversa): sidebar branca com ícones, banner degradê, cards de
// modo com chip de ícone e seta, usuário em balão cinza claro, resposta do
// assistente em texto plano e opções em painel com linhas numeradas.

export const Page = styled.div<{ $bottomOffset?: number }>`
  /* Header do app é fixo (56px) — mesmo padrão de layout da Central IA */
  display: flex;
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: ${({ $bottomOffset = 0 }) => $bottomOffset}px;
  overflow: hidden;
  background: ${colors.$white};
  color: #1f2a37;
`;

export const Sidebar = styled.aside`
  width: 260px;
  min-width: 260px;
  background: ${colors.$white};
  border-right: 1px solid #e5e9e7;
  display: flex;
  flex-direction: column;
  padding: 18px 12px 14px;
  /* O scroll fica no miolo (SidebarScroll); título e rodapé são fixos */
  overflow: hidden;

  h1 {
    font-size: 17px;
    font-weight: 700;
    padding: 0 10px 14px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    /* Recolher o menu quando o painel da petição está aberto */
    button {
      display: inline-flex;
      border: none;
      background: none;
      padding: 2px;
      border-radius: 6px;
      color: #8a948f;
      cursor: pointer;

      &:hover {
        background: #f1f4f2;
      }
    }
  }

  h2 {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #8a948f;
    margin: 20px 10px 6px;
  }
`;

// Miolo rolável da sidebar — o "Veja como funciona" fica preso embaixo
export const SidebarScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d6dcd8;
    border-radius: 3px;
  }
`;

// Item do histórico: título em linha única com reticências e exclusão
// discreta no hover (a peça salva não é afetada — só a conversa some)
export const HistoryItem = styled.div<{ active?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${({ active }) => (active ? '#eef3f0' : 'transparent')};

  &:hover {
    background: #f2f5f3;
  }

  > button:first-child {
    flex: 1;
    min-width: 0;
    border: none;
    background: none;
    text-align: left;
    padding: 8px 2px 8px 10px;
    font-size: 13.5px;
    line-height: 1.4;
    color: #3d4a44;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  > button:not(:first-child) {
    border: none;
    background: none;
    padding: 6px 8px;
    cursor: pointer;
    line-height: 0;
    opacity: 0;
    flex-shrink: 0;

    i {
      font-size: 15px;
      color: #8a948f;
    }

    &:hover i {
      color: #21354a;
    }
  }

  &:hover > button:not(:first-child),
  &:focus-within > button:not(:first-child) {
    opacity: 1;
  }
`;

export const HistoryMenu = styled.div`
  position: absolute;
  top: calc(100% - 2px);
  right: 4px;
  z-index: 30;
  min-width: 185px;
  background: #fff;
  border: 1px solid #dde2e4;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(33, 53, 74, 0.18);
  padding: 4px;

  button {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    border: none;
    background: none;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 13.5px;
    color: #21354a;
    cursor: pointer;
    text-align: left;

    i {
      font-size: 16px;
      color: #5c6b7a;
    }

    &:hover {
      background: #f2f5f3;
    }

    &.perigo {
      color: #c0392b;

      i {
        color: #c0392b;
      }
    }
  }
`;

export const MenuOverlay = styled.button`
  position: fixed;
  inset: 0;
  z-index: 20;
  border: none;
  background: transparent;
  cursor: default;
`;

// Aviso flutuante de confirmação (some sozinho)
const toastIn = keyframes`
  from { opacity: 0; transform: translate(-50%, 8px); }
  to { opacity: 1; transform: translate(-50%, 0); }
`;

export const Toast = styled.div`
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  background: #21354a;
  color: #fff;
  font-size: 13.5px;
  padding: 10px 18px;
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(31, 42, 55, 0.25);
  z-index: 60;
  animation: ${toastIn} 0.18s ease-out;
`;

// Opção de projeto no modal "Mover para projeto"
export const ProjectOption = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: none;
  background: #f5f7f6;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #2c3a34;
  text-align: left;
  cursor: pointer;

  i {
    font-size: 18px;
    color: #5b6862;
  }

  &:hover {
    background: #e9efec;
  }
`;

export const SidebarFooter = styled.div`
  border-top: 1px solid #eef1ef;
  margin-top: 10px;
  padding: 12px 10px 0;
  flex-shrink: 0;

  button {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: none;
    color: ${colors.$primary};
    font-size: 13.5px;
    cursor: pointer;
    padding: 0;

    i {
      font-size: 18px;
    }
  }
`;

export const SidebarButton = styled.button<{ active?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: none;
  background: ${({ active }) => (active ? '#eef3f0' : 'transparent')};
  color: ${({ disabled }) => (disabled ? '#b3bcb7' : '#2c3a34')};
  font-size: 14px;
  text-align: left;
  padding: 8px 10px;
  flex-shrink: 0;
  border-radius: 8px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  i {
    font-size: 18px;
    color: ${({ disabled }) => (disabled ? '#c3cbc6' : '#5b6862')};
  }

  &:hover {
    background: ${({ disabled }) => (disabled ? 'transparent' : '#f2f5f3')};
  }

  /* Renderizado como Link (<a>) nas páginas: sem o azul/sublinhado de âncora */
  &,
  &:hover,
  &:focus,
  &:active {
    color: ${({ disabled }) => (disabled ? '#b3bcb7' : '#2c3a34')};
    text-decoration: none;
    outline: none;
  }

  small {
    color: #b3bcb7;
    margin-left: auto;
    font-size: 11px;
  }
`;

export const Main = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  /* Todo o lado direito no azul-claríssimo do protótipo, sem faixas brancas */
  background: #f5f7fa;
`;

export const Banner = styled.div`
  margin: 18px 28px 0;
  padding: 11px 18px;
  border-radius: 8px;
  border: 1px solid #bfe3cf;
  background: linear-gradient(90deg, #eaf3ff 0%, #e9f9ef 100%);
  color: #17423b;
  font-size: 13.5px;
  font-weight: 700;
  text-align: center;
`;

export const Welcome = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;

  h2 {
    font-size: 36px;
    font-weight: 800;
    margin-bottom: 6px;
    color: #21354a;
  }

  p {
    font-size: 14.5px;
    font-weight: 700;
    color: #3d4a44;
    margin-bottom: 32px;
  }
`;

export const ModeCards = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const ModeCard = styled.button<{ disabled?: boolean }>`
  width: 368px;
  text-align: left;
  background: ${colors.$white};
  border: 1px solid #366793;
  border-radius: 14px;
  padding: 22px 20px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};
  display: flex;
  gap: 16px;
  align-items: flex-start;

  &:hover {
    border-color: ${({ disabled }) => (disabled ? '#366793' : '#2c5278')};
    box-shadow: ${({ disabled }) => (disabled ? 'none' : '0 3px 12px rgba(33, 53, 74, 0.1)')};
  }
`;

export const ModeCardIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 12px;
  background: #ccddeb;

  i {
    font-size: 28px;
    color: #21354a;
  }
`;

export const ModeCardBody = styled.span`
  flex: 1;

  strong {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 19px;
    font-weight: 800;
    color: #21354a;
    margin-bottom: 6px;

    i {
      font-size: 26px;
      color: #366793;
      margin-left: 8px;
    }
  }

  span {
    display: block;
    font-size: 14.5px;
    line-height: 1.45;
    color: #366793;
  }
`;

// Escolha do tipo de peça (Construir Petição): cards dos tipos, input embaixo
export const Landing = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 32px 24px;

  h2 {
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 6px;
    color: #21354a;
  }

  p {
    font-size: 14.5px;
    font-weight: 700;
    color: #3d4a44;
    margin-bottom: 26px;
  }
`;

export const TipoCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: 14px;
  width: 100%;
  max-width: 1000px;
`;

export const TipoCard = styled.button`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
  background: ${colors.$white};
  border: 1px solid #366793;
  border-radius: 8px;
  padding: 14px;
  cursor: pointer;

  ${ModeCardIcon} {
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 4px;

    i {
      font-size: 20px;
    }
  }

  ${ModeCardBody} {
    strong {
      font-size: 15px;
      font-weight: 700;
      letter-spacing: -0.3px;
      margin-bottom: 4px;

      i {
        font-size: 18px;
      }
    }

    span {
      font-size: 13.5px;
      line-height: 1.3;
      letter-spacing: -0.28px;
    }
  }

  &:hover {
    border-color: #2c5278;
    box-shadow: inset 0 0 0 1px #2c5278;
  }
`;

export const ChatArea = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;
`;

export const Conversation = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

// Cabeçalho da conversa: título, renomear e menu de ações (como no IAgov)
export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 28px 10px;
  border-bottom: 1px solid #e2e7ea;

  h3 {
    margin: 0;
    min-width: 0;
    font-size: 17px;
    font-weight: 800;
    color: #21354a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button.icone {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: none;
    background: none;
    border-radius: 6px;
    color: #5c6b7a;
    cursor: pointer;

    i {
      font-size: 18px;
    }

    &:hover {
      background: #e9edef;
      color: #21354a;
    }
  }
`;

export const ChatHeaderMenu = styled.div`
  position: relative;
  margin-left: auto;
`;

export const Messages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const MessagesInner = styled.div`
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

// Tipografia do markdown das respostas (listas numeradas com títulos em
// negrito, subtítulos, transcrições em blockquote — padrão das respostas
// do acervo no modo Dúvidas)
const markdownContent = css`
  overflow-wrap: break-word;

  p {
    margin: 0 0 10px;
  }

  ul,
  ol {
    margin: 4px 0 12px;
    padding-left: 22px;
  }

  li {
    margin-bottom: 10px;
    padding-left: 4px;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      margin-bottom: 4px;
    }
  }

  li > strong:first-child {
    display: inline-block;
    margin-bottom: 2px;
  }

  h1,
  h2,
  h3,
  h4 {
    font-size: 15px;
    font-weight: 700;
    color: #21354a;
    margin: 16px 0 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  blockquote {
    margin: 0 0 10px;
    padding: 6px 14px;
    border-left: 3px solid #b9cbdd;
    background: rgba(185, 203, 221, 0.18);
    border-radius: 0 6px 6px 0;
    color: #3d4c5c;
    font-size: 14px;

    p:last-child {
      margin-bottom: 0;
    }
  }

  hr {
    border: none;
    border-top: 1px solid #dde2e4;
    margin: 12px 0;
  }

  a {
    color: #007bff;
    /* URLs longas (utm etc.) não têm ponto de quebra natural */
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  table {
    border-collapse: collapse;
    margin: 4px 0 12px;
    font-size: 13.5px;

    th,
    td {
      border: 1px solid #ccd4da;
      padding: 6px 10px;
      text-align: left;
    }

    th {
      background: #e2e7ea;
    }
  }

  code {
    background: #e2e7ea;
    border-radius: 4px;
    padding: 1px 5px;
    font-size: 13px;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

export const Bubble = styled.div<{ role: 'user' | 'assistant' }>`
  font-size: 14.5px;
  line-height: 1.6;
  color: #1f2a37;

  ${markdownContent}

  ${({ role }) =>
    role === 'user'
      ? `
        max-width: 70%;
        align-self: flex-end;
        background: #e9edef;
        border-radius: 10px;
        padding: 9px 14px;
      `
      : `
        max-width: 100%;
        align-self: stretch;
        background: transparent;
        padding: 0;
      `}
`;

// Resposta do assistente no estilo IAgov: avatar circulado ao pé da bolha,
// cabeçalho "DR. LICITA • ASSISTENTE" e conteúdo em bolha cinza arredondada
export const AssistantRow = styled.div`
  align-self: stretch;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  /* Respiro ao ancorar o auto-scroll no início da bolha */
  scroll-margin-top: 14px;
`;

export const AssistantBubble = styled.div`
  flex: 1;
  min-width: 0;
  background: #eceff1;
  border-radius: 18px;
  border-bottom-left-radius: 4px;
  padding: 14px 22px 16px;
  font-size: 14.5px;
  line-height: 1.6;
  color: #1f2a37;

  ${markdownContent}

  header {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1.6px;
    color: #5c6b7a;
    margin-bottom: 8px;

    em {
      font-style: normal;
      color: #5c7fa8;
      font-size: 9px;
    }
  }
`;

export const OptionsBlock = styled.div`
  align-self: stretch;
  /* Alinhado à bolha do assistente (avatar 38px + gap 12px) */
  margin-left: 50px;
  background: #eceff1;
  border-radius: 12px;
  padding: 14px 16px;

  strong {
    display: block;
    font-size: 14px;
    margin-bottom: 8px;
    color: #1f2a37;
  }
`;

export const OptionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  border-bottom: 1px solid #dde2e4;
  padding: 9px 4px;
  font-size: 14px;
  color: #1f2a37;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  b {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 22px;
    border-radius: 5px;
    background: #b9cbdd;
    color: #23405c;
    font-size: 12.5px;
  }

  &:hover {
    background: #e2e7ea;
  }
`;

export const SavedNotice = styled.div`
  align-self: flex-start;
  background: ${colors.$success_light_bg};
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;

  a {
    font-weight: 600;
    margin-left: 6px;
  }
`;

// Avaliação 👍/👎 discreta ao pé da resposta do assistente
export const RatingRow = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 10px;

  button {
    border: none;
    background: none;
    padding: 3px;
    cursor: pointer;
    border-radius: 6px;
    line-height: 0;

    i {
      font-size: 17px;
      color: #90a0ad;
    }

    &:hover {
      background: #e0e5e9;
    }

    &.active i {
      color: #23405c;
    }
  }
`;

// Bolha de espera no estilo IAgov: avatar circulado + "DR. LICITA • PENSANDO",
// texto da etapa em execução (via SSE) e pontinhos pulsando
const dotPulse = keyframes`
  0%, 80%, 100% { opacity: 0.25; transform: scale(0.85); }
  40% { opacity: 1; transform: scale(1); }
`;

export const Thinking = styled.div`
  align-self: flex-start;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  max-width: 80%;
`;

export const ThinkingAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #5c7fa8;
  background: #fff;
  flex-shrink: 0;

  i {
    font-size: 20px;
    color: #23405c;
  }
`;

export const ThinkingBubble = styled.div`
  background: #eceff1;
  border-radius: 18px;
  border-bottom-left-radius: 4px;
  padding: 12px 20px 14px;

  header {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1.6px;
    color: #5c6b7a;

    em {
      font-style: normal;
      color: #e6a23c;
      font-size: 9px;
    }
  }

  p {
    margin: 7px 0 0;
    font-size: 13.5px;
    color: #3d4a55;
  }
`;

export const ThinkingSteps = styled.ul`
  list-style: none;
  margin: 9px 0 0;
  padding: 0;

  li {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 0;
    font-size: 13.5px;
    color: #3d4a55;

    .material-icons {
      font-size: 16px;
      color: #2e7d32;
    }
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const StepSpinner = styled.span`
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid #c3ced6;
  border-top-color: #23405c;
  animation: ${spin} 0.8s linear infinite;
`;

export const ThinkingDots = styled.span`
  display: flex;
  gap: 5px;
  margin-top: 9px;

  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #90a0ad;
    animation: ${dotPulse} 1.2s ease-in-out infinite;
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

export const InputRegion = styled.div`
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
  padding: 8px 24px 0;
`;

export const InputBar = styled.form`
  display: flex;
  /* Ícones acompanham a base quando o textarea cresce (estilo Claude) */
  align-items: flex-end;
  gap: 10px;
  background: ${colors.$white};
  border: 1px solid #d6dcd8;
  border-radius: 10px;
  padding: 6px 8px 6px 12px;

  &:focus-within {
    border-color: ${colors.$primary};
  }

  i {
    font-size: 20px;
    color: #9aa5a0;
  }

  /* Ícone do microfone centrado na altura de uma linha */
  > i {
    line-height: 40px;
  }

  textarea {
    flex: 1;
    resize: none;
    /* Auto-expande via JS até o teto; depois rola internamente */
    min-height: 40px;
    max-height: 200px;
    overflow-y: auto;
    border: none;
    padding: 9px 4px;
    font-size: 14.5px;
    line-height: 1.5;
    background: transparent;

    &:focus {
      outline: none;
    }
  }

  button[type='submit'],
  button.parar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 40px;
    border: none;
    border-radius: 8px;
    background: ${colors.$primary};
    color: ${colors.$white};
    cursor: pointer;

    i {
      color: ${colors.$white};
      font-size: 19px;
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  /* Parar a resposta do Atendimento: no lugar do Enviar enquanto ela sai */
  button.parar {
    background: #1f2a37;
  }
`;

export const AttachButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;

  i {
    font-size: 20px;
    color: #9aa5a0;
  }

  &:hover i {
    color: #5b6862;
  }
`;

export const Disclaimer = styled.div`
  text-align: center;
  color: #9aa5a0;
  font-size: 12px;
  padding: 8px 0 14px;
`;

export const DraftPanel = styled.aside`
  /* Cresce com a tela; recolhível pelo header */
  width: 44%;
  min-width: 440px;
  max-width: 640px;
  border-left: 1px solid #e5e9e7;
  background: #eef1f4;
  overflow-y: auto;
  padding: 18px 20px;

  h3 {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #8a948f;
    margin-bottom: 0;
  }
`;

export const DraftPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  button {
    border: none;
    background: none;
    padding: 2px;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #8a948f;
    }

    &:hover i {
      color: #23405c;
    }
  }
`;

export const DraftRail = styled.aside`
  width: 46px;
  min-width: 46px;
  border-left: 1px solid #e5e9e7;
  background: #eef1f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-top: 12px;

  button {
    border: none;
    background: none;
    padding: 4px;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #5c6b7a;
    }

    &:hover i {
      color: #23405c;
    }
  }

  span {
    writing-mode: vertical-rl;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #8a948f;
  }
`;

// "Folha" do documento: preview com cara da peça final (serif, título
// centralizado, texto justificado), como o PDF exportado hoje
export const DraftSheet = styled.div`
  background: ${colors.$white};
  border: 1px solid #dde2e6;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(31, 42, 55, 0.08);
  padding: 28px 26px;
  font-family: Georgia, 'Times New Roman', serif;
  color: #1f2a37;

  h4 {
    text-align: center;
    text-transform: uppercase;
    font-size: 14.5px;
    letter-spacing: 0.04em;
    margin-bottom: 24px;
  }
`;

export const Verification = styled.div<{ ok: boolean }>`
  font-size: 12px;
  border-radius: 6px;
  padding: 7px 12px;
  margin-bottom: 14px;
  background: ${({ ok }) => (ok ? colors.$success_light_bg : colors.$danger_light_bg)};
  color: ${({ ok }) => (ok ? colors.$dark_green : colors.$danger)};
`;

export const DraftSection = styled.div`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  h5 {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 8px;
  }

  p {
    font-size: 13.5px;
    line-height: 1.7;
    text-align: justify;
    margin-bottom: 10px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  /* Transcrições de lei/jurisprudência, como nas minutas */
  blockquote {
    margin: 10px 0 10px 24px;
    padding-left: 14px;
    border-left: 2px solid #c3ccd4;
    font-style: italic;

    p {
      font-size: 13px;
    }
  }

  ul {
    padding-left: 22px;
    margin-bottom: 10px;

    li {
      font-size: 13.5px;
      line-height: 1.7;
    }
  }
`;

// Proveniência recolhida: não compete visualmente com o texto da peça
export const LiteralDetails = styled.details`
  font-family: ${'-apple-system, BlinkMacSystemFont, sans-serif'};
  margin-top: 10px;

  summary {
    cursor: pointer;
    font-size: 11.5px;
    font-weight: 600;
    color: ${colors.$dark_green};
    user-select: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Literal = styled.blockquote`
  border-left: 3px solid ${colors.$dark_green};
  background: #f4f9f6;
  padding: 8px 12px;
  margin: 8px 0 0;
  font-size: 12.5px;
  font-style: italic;

  b {
    display: block;
    font-style: normal;
    font-size: 11px;
    color: ${colors.$dark_green};
  }
`;

// Sidebar recolhida em trilho de ícones (painel da petição aberto)
export const SidebarRail = styled.nav`
  width: 56px;
  min-width: 56px;
  background: ${colors.$white};
  border-right: 1px solid #e5e9e7;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 16px 0;

  button,
  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: none;
    border-radius: 8px;
    background: none;
    color: #4b5563;
    cursor: pointer;

    &:hover {
      background: #f1f4f2;
      text-decoration: none;
    }
  }
`;

// "Tentar novamente" de uma resposta que falhou
export const RetryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 5px 12px;
  border: 1px solid #d6dcd8;
  border-radius: 999px;
  background: ${colors.$white};
  font-size: 13px;
  color: #1f2a37;
  cursor: pointer;

  i {
    font-size: 16px;
  }

  &:hover {
    border-color: ${colors.$primary};
  }
`;

// Pergunta que ficou sem resposta (o turno morreu no meio)
export const LostReply = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 13px;
  color: #8a948f;
`;

// Atalhos de casos comuns logo abaixo da abertura do Atendimento
export const CasosComuns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 4px 0 8px 48px;

  button {
    padding: 7px 14px;
    border: 1px solid #d6dcd8;
    border-radius: 999px;
    background: ${colors.$white};
    font-size: 13px;
    color: #1f2a37;
    cursor: pointer;

    &:hover {
      border-color: ${colors.$primary};
      color: ${colors.$primary};
    }
  }
`;
